<template>
  <b-modal
      v-model="show"
      v-if="show"
      centered
      hide-footer
      title="آیا برای حذف این فایل مطمئن هستید؟"
      :no-close-on-backdrop="true"
      size="md"
  >
    <div class="text-center mt-2">
      <b-overlay :show="loading" rounded spinner-small class="d-inline-block">
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="danger"
            class="mr-1"
            :disabled="loading"
            @click="submit"
        >
          حذف
        </b-button>
      </b-overlay>
      <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('update:show', !show)"
      >
        انصراف
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "fmDeleteFile",
  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    submit() {
      this.$emit('delete')
      this.$emit('update:show', !this.show)
    },
  }
}
</script>